import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// Remove pre-rendered SEO content before React takes over
const prerendered = rootElement.querySelector('[data-prerendered]');
if (prerendered) {
  prerendered.remove();
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
